import './App.css';
import BackgroundAIBlue from './components/BackgroundAI';
import { useResponsive } from './hooks/useResponsive';

function App() {
  const { isTablet, isLaptop, isDesktop } = useResponsive();

  // Responsive background settings
  const getBackgroundSettings = () => {
    if (isDesktop) {
      return {
        nodeCount: 140,
        linkDistance: 120,
        cursorLinkDistance: 160,
        layers: 3,
        speed: 0.3
      };
    } else if (isLaptop) {
      return {
        nodeCount: 120,
        linkDistance: 110,
        cursorLinkDistance: 150,
        layers: 3,
        speed: 0.3
      };
    } else if (isTablet) {
      return {
        nodeCount: 80,
        linkDistance: 100,
        cursorLinkDistance: 130,
        layers: 2,
        speed: 0.25
      };
    } else {
      return {
        nodeCount: 50,
        linkDistance: 80,
        cursorLinkDistance: 110,
        layers: 2,
        speed: 0.2
      };
    }
  };

  const bgSettings = getBackgroundSettings();

  return (
    <div className="App">
      <BackgroundAIBlue 
        nodeCount={bgSettings.nodeCount}
        linkDistance={bgSettings.linkDistance}
        cursorLinkDistance={bgSettings.cursorLinkDistance}
        layers={bgSettings.layers}
        speed={bgSettings.speed}
        hue={25}
        saturation={100}
        lightness={50}
        background="transparent"
        mode="fixed" 
      />
      <div className="hero-section">
        <div className="coming-soon-container">
          <h1 className="coming-soon-title">COMING SOON</h1>
        </div>
        
        <div className="container">
          <div className="content">
            <h2 className="main-title">RWL COIN</h2>
            <h3 className="subtitle">Real World Liquidity Coin</h3>
            <p className="description">Bridging Digital Currency with Real World Value</p>
            
            <div className="features">
              <div className="feature-item">
                <div className="feature-icon">⚖️</div>
                <span>Legal Framework</span>
              </div>
              <div className="feature-item">
                <div className="feature-icon">💰</div>
                <span>Real World Assets</span>
              </div>
              <div className="feature-item">
                <div className="feature-icon">🔗</div>
                <span>Blockchain Technology</span>
              </div>
            </div>
          </div>
          
        </div>
      </div>
    </div>
  );
}

export default App;
